import React, { useEffect, useState } from "react";
import Select, { createFilter, OptionsType } from "react-select";
import { FixedSizeList as List } from "react-window";
import "./Select.css";

export class MenuList extends React.Component<any> {
  height: number = 35;

  render() {
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * this.height;

    return (
      <List
        height={maxHeight}
        // @ts-ignore
        itemCount={children.length}
        itemSize={this.height}
        initialScrollOffset={initialOffset}
        width="100%"
      >
        {({ index, style }) => {
          // @ts-ignore
          return <div style={style}>{children[index]}</div>;
        }}
      </List>
    );
  }
}

let allStates: Array<{ label: string; value: string }> = [
  {
    state: "Alabama",
    abbr: "AL",
  },
  {
    state: "Alaska",
    abbr: "AK",
  },
  {
    state: "Arizona",
    abbr: "AZ",
  },
  {
    state: "Arkansas",
    abbr: "AR",
  },
  {
    state: "California",
    abbr: "CA",
  },
  {
    state: "Colorado",
    abbr: "CO",
  },
  {
    state: "Connecticut",
    abbr: "CT",
  },
  {
    state: "Delaware",
    abbr: "DE",
  },
  {
    state: "Florida",
    abbr: "FL",
  },
  {
    state: "Georgia",
    abbr: "GA",
  },
  {
    state: "Hawaii",
    abbr: "HI",
  },
  {
    state: "Idaho",
    abbr: "ID",
  },
  {
    state: "Illinois",
    abbr: "IL",
  },
  {
    state: "Indiana",
    abbr: "IN",
  },
  {
    state: "Iowa",
    abbr: "IA",
  },
  {
    state: "Kansas",
    abbr: "KS",
  },
  {
    state: "Kentucky",
    abbr: "KY",
  },
  {
    state: "Louisiana",
    abbr: "LA",
  },
  {
    state: "Maine",
    abbr: "ME",
  },
  {
    state: "Maryland",
    abbr: "MD",
  },
  {
    state: "Massachusetts",
    abbr: "MA",
  },
  {
    state: "Michigan",
    abbr: "MI",
  },
  {
    state: "Minnesota",
    abbr: "MN",
  },
  {
    state: "Mississippi",
    abbr: "MS",
  },
  {
    state: "Missouri",
    abbr: "MO",
  },
  {
    state: "Montana",
    abbr: "MT",
  },
  {
    state: "Nebraska",
    abbr: "NE",
  },
  {
    state: "Nevada",
    abbr: "NV",
  },
  {
    state: "New Hampshire",
    abbr: "NH",
  },
  {
    state: "New Jersey",
    abbr: "NJ",
  },
  {
    state: "New Mexico",
    abbr: "NM",
  },
  {
    state: "New York",
    abbr: "NY",
  },
  {
    state: "North Carolina",
    abbr: "NC",
  },
  {
    state: "North Dakota",
    abbr: "ND",
  },
  {
    state: "Ohio",
    abbr: "OH",
  },
  {
    state: "Oklahoma",
    abbr: "OK",
  },
  {
    state: "Oregon",
    abbr: "OR",
  },
  {
    state: "Pennsylvania",
    abbr: "PA",
  },
  {
    state: "Rhode Island",
    abbr: "RI",
  },
  {
    state: "South Carolina",
    abbr: "SC",
  },
  {
    state: "South Dakota",
    abbr: "SD",
  },
  {
    state: "Tennessee",
    abbr: "TN",
  },
  {
    state: "Texas",
    abbr: "TX",
  },
  {
    state: "Utah",
    abbr: "UT",
  },
  {
    state: "Vermont",
    abbr: "VT",
  },
  {
    state: "Virginia",
    abbr: "VA",
  },
  {
    state: "Washington",
    abbr: "WA",
  },
  {
    state: "West Virginia",
    abbr: "WV",
  },
  {
    state: "Wisconsin",
    abbr: "WI",
  },
  {
    state: "Wyoming",
    abbr: "WY",
  },
].map((state) => ({
  label: state.state + ", " + state.abbr,
  value: state.state,
}));

const SelectCity: React.FunctionComponent<{
  onChange?: (e: { label: string; value: string }) => void;
  value?: string;
}> = (props: {
  onChange?: (e: { label: string; value: string }) => void;
  value?: string;
}) => {
  const [value, setValue] = useState<string>(props.value ? props.value : "");
  const [states, setStates] =
    useState<OptionsType<{ label: string; value: string }>>(allStates);
  const [loading, setLoading] = useState<boolean>(false);
  const [selected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    console.log(value);
  }, [value]);

  const handleInputChange = (e: string) => {
    // setValue(e);
    setSelected(true);
  };

  const handleChange = (e: { label: string; value: string } | null) => {
    if (e) {
      setValue(e.value);
      if (props.onChange) props.onChange(e);
    }
    setSelected(false);
  };

  return (
    <div>
      <Select
        options={states}
        onChange={handleChange}
        value={{ label: value ? value : "Select State", value }}
        filterOption={createFilter({ ignoreAccents: true })}
        className="select-menu"
        openOnClick={true}
        styles={{
          valueContainer: () => ({
            padding: "0.55rem 0.8rem",
            fontSize: "1.1rem",
            color: "#333",
          }),
        }}
        onFocus={() => setSelected(true)}
        onInputChange={handleInputChange}
        placeholder="Search State"
      />
    </div>
  );
};

export default SelectCity;
